import { z } from 'zod';

/**
 * 事件类型枚举（游戏时序通道）。
 */
export const GameEventType = z.enum(['system', 'combat', 'exploration', 'quest']);
export type GameEventTypeValue = z.infer<typeof GameEventType>;

/**
 * 事件级别枚举。
 */
export const GameEventLevel = z.enum(['info', 'warn', 'error']);
export type GameEventLevelValue = z.infer<typeof GameEventLevel>;

/**
 * 游戏事件条目。
 */
export const GameEventEntrySchema = z.object({
  id: z.string(),
  timestamp: z.number(),
  gameTime: z.string().optional(),
  type: GameEventType,
  level: GameEventLevel.default('info'),
  content: z.string(),
  metadata: z.record(z.string(), z.any()).optional(),
});

export type GameEventEntry = z.infer<typeof GameEventEntrySchema>;

/**
 * 事件通道状态。
 */
export const GameEventStateSchema = z.object({
  events: z.array(GameEventEntrySchema),
  maxEvents: z.number().default(300),
});
export type GameEventState = z.infer<typeof GameEventStateSchema>;

// ============================================
// 事件写入参数与上下文元数据
// ============================================

/**
 * 事件重要度。
 */
export type GameEventImportance = 'low' | 'normal' | 'high' | 'critical';

/**
 * 事件发生位置上下文。
 */
export interface GameEventLocationContext {
  country?: string;
  zoneId?: string | number;
  zoneName?: string;
  interiorBuildingId?: string;
  explorationId?: string;
  roomId?: string;
}

/**
 * 附加在事件元数据上的上下文信息。
 */
export interface GameEventContextMetadata {
  subtype?: string;
  importance: GameEventImportance;
  source?: string;
  tags?: string[];
  location?: GameEventLocationContext;
}

/**
 * 追加事件的入参。
 */
export interface AppendGameEventParams {
  type: GameEventTypeValue;
  content: string;
  level?: GameEventLevelValue;
  subtype?: string;
  importance?: GameEventImportance;
  source?: string;
  tags?: string[];
  location?: GameEventLocationContext;
  metadata?: Record<string, unknown>;
}
